import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addUpgrade from './addUpgrade';
import viewUpgrade from './viewUpgrade';
import resultUpgrade from './resultUpgrade';
export default {
  name: 'upgradeUser',
  data: function data() {
    return {
      hasMomal: false,
      submitLoading: false,
      currCom: '',
      current: 1,
      countdown: '',
      status: null,
      resultData: {}
    };
  },
  components: {
    addUpgrade: addUpgrade,
    viewUpgrade: viewUpgrade,
    resultUpgrade: resultUpgrade
  },
  props: {
    title: {
      type: String,
      default: '查看企业账号'
    },
    width: {
      type: Number,
      default: 900
    },
    TreeData: {}
  },
  methods: {
    init: function init() {
      var _this = this;

      this.$store.dispatch('handleenterprise_audit_count_down', {}).then(function (res) {
        if (res.result === 0) {
          var status = res.body.status; //0为未提交企业认证，，1为等待审核，2为审核通过，3为审核失败

          _this.status = status;

          if (status === 0) {
            //未提交企业认证
            _this.current = 0;
            _this.currCom = 'addUpgrade'; //切换到添加界面
          } else {
            _this.current = 2;
            _this.currCom = 'resultUpgrade'; //切换到结果界面

            _this.resultData = {
              countdown: res.body.count_down,
              enterprise_name: res.body.enterprise_name,
              enterprise_audit_desc: res.body.enterprise_audit_desc,
              status: status
            };

            _this.$nextTick(function () {
              _this.$refs[_this.currCom].init();
            });
          }
        } else {
          _this.$Message.error(res.errorMsg);
        }
      });
    },
    showModal: function showModal(b) {
      this.hasMomal = b;
    },
    close: function close() {
      this.showModal(false);
    },

    /**
     * 上一步操作
     */
    last: function last() {
      var _this2 = this;

      this.currCom = 'addUpgrade';
      this.current = 0;
      this.$nextTick(function () {
        _this2.$refs[_this2.currCom].backData(_this2.resultData);
      });
    },

    /**
     * 下一步操作
     */
    next: function next() {
      var vm = this;
      this.$refs[this.currCom].goSubmitStep().then(function (obj) {
        vm.current = 1;
        vm.currCom = 'viewUpgrade';
        vm.resultData = obj;
        vm.$nextTick(function () {
          vm.$refs[vm.currCom].init();
        });
      });
    },

    /**
     * 提交数据
     */
    submitData: function submitData() {
      var _this3 = this;

      var vm = this;

      var callback = function callback(res) {
        _this3.submitLoading = false;

        if (res.result === 0) {
          _this3.$Message.success(res.errorMsg);

          _this3.current = 2;
          _this3.currCom = 'resultUpgrade';
          vm.$nextTick(function () {
            _this3.$res[_this3.currCom].init();
          });
        } else {
          _this3.$Message.error(res.errorMsg);
        }
      };

      this.submitLoading = true;
      this.$store.dispatch('handleEnterprise', this.resultData).then(function (res) {
        callback(res);
      });
    },

    /**
     * 重新提交企业认证信息
     */
    resetAuthener: function resetAuthener() {
      this.current = 0;
      this.currCom = 'addUpgrade';
    },
    onVisibleChange: function onVisibleChange(b) {
      if (b) {
        this.init();
      } else {
        this.showModal(false);
      }
    }
  }
};